export default "__VITE_ASSET__17b5e3f5__"